import { render, staticRenderFns } from "./BatchApprovePrint.pug?vue&type=template&id=918b969e&scoped=true&lang=pug&"
import script from "./BatchApprovePrint.vue?vue&type=script&lang=js&"
export * from "./BatchApprovePrint.vue?vue&type=script&lang=js&"
import style0 from "./BatchApprovePrint.scss?vue&type=style&index=0&id=918b969e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "918b969e",
  null
  
)

export default component.exports